import { useClientState } from '@state/useClientState';
import { useStoreOutlet } from '@state/useStoreOutlet';
import { useStoreAppData } from '@state/useGlobalState';
import { sendPostMessageToParent } from '@functions/trafficController';
import { useHistory } from 'react-router-dom';
import { saveTypeUser } from '@data/localStorageSetter';
import useCheckSalesType from './useCheckSalesType';
import URLS from '@/URLS';
import { useEffect, useState } from 'react';
import useClientAmplify from './useClientAmplify';
import { useTokenCredentials } from '@state/useTokenCredentials';
import { useMiniappConfirm } from '@state/useMiniappConfirm';
import { getDB } from '@/InitiateRxdb';
import { useGeneralContext } from '@context/GeneralContext';
import { useStoreSettings } from '@state/useStoreSettings';
import { useLambdaFunctionContext } from '@context/LambdaFunctionContext';
import { ObjectId } from 'bson';
import useHITApi from '@hooks/useHITApi';
import { insertMiniappStoreLogUtil } from '@hooks/useInsertMiniappStoreLog';

const now = new Date();
const fiveMinutesAgo = Number(new Date(now.getTime() - 5 * 60 * 1000));
export default function useRxdbStoreLog(credminiapp) {
  const { appData } = useStoreAppData((state) => ({ appData: state.appData }));
  const { config } = appData;
  const [from, setFrom] = useState('');
  const [retryCounter, setRetryCounter] = useState(1);

  const { showGreetingModal } = useGeneralContext();
  const { setLocalState } = useLambdaFunctionContext();

  const { settings } = useStoreSettings((state) => ({
    settings: state.settings,
  }));

  const history = useHistory();
  const checkSalesType = useCheckSalesType();
  const [clientAmplify] = useClientAmplify();
  const hitAPI = useHITApi();

  const { getClient, updateClient } = useClientState((state) => ({
    getClient: state.getClient,
    updateClient: state.updateClient,
  }));

  const { getOutletInfo, getOutletId } = useStoreOutlet((state) => ({
    getOutletInfo: state.getOutletInfo,
    getOutletId: state.getOutletId,
  }));

  const { updateMiniappConfirm, getMiniappConfirmId, updateMiniappConfirmId } = useMiniappConfirm((state) => ({
    updateMiniappConfirm: state.updateMiniappConfirm,
    getMiniappConfirmId: state.getMiniappConfirmId,
    updateMiniappConfirmId: state.updateMiniappConfirmId
  }));

  const restrictedUrls = [
    URLS.SESSION_EXPIRED,
    URLS.INVALID_TOKEN,
    URLS.MINIAPP_FAILURE,
    URLS.CANNOT_SICC,
    URLS.OUTLET_CLOSE,
    URLS.CONNECTION_FAILURE,
    URLS.BROWSER_NOT_SUPPORTED,
  ];

  const { getTokenCredentials } = useTokenCredentials((state) => ({
    getTokenCredentials: state.getTokenCredentials,
  }));

  const redirectUrl = () => {
    if (config.display_login) {
      if (settings.popupUrl) {
        showGreetingModal(() => {
          sendPostMessageToParent('path', URLS.LOGIN);
          history.replace(URLS.LOGIN);
        });
      } else {
        sendPostMessageToParent('path', URLS.LOGIN);
        history.replace(URLS.LOGIN);
      }
    } else {
      saveTypeUser('guest');
      ///dari qrstore config tableID null
      ///direct langsung ke takeaway
      ///jika null ke normal biasanya kalo ada isinya baru force
      const newUrlRedirect = checkSalesType();
      if (!restrictedUrls.includes(newUrlRedirect) && settings.popupUrl) {
        showGreetingModal(() => {
          sendPostMessageToParent('path', newUrlRedirect);
          history.replace(newUrlRedirect);
        });
      } else {
        sendPostMessageToParent('path', newUrlRedirect);
        history.replace(newUrlRedirect);
      }
    }
  };

  // const miniappSplash = async (param1, param2) => {
  //   setNext(false);
  //   setFrom(param1);
  //   setId(param2);
  //   const query = await queryLog();
  //   if (query && Number(query.timestamp) >= fiveMinutesAgo) {
  //     redirectUrl();
  //     return;
  //   } else {
  //     await insertStoreLog(param2);
  //   }
  // };

  // const miniappConfirm = async (param1, param2) => {
  //   setNext(false);
  //   setFrom(param1);
  //   setId(param2);
  //   await insertStoreLog(param2);
  // };

  // const queryLog = async () => {
  //   const db = await getDB();
  //   if (!db || !db.storelog) {
  //     console.error('Database or storelog collection not ready');
  //     return null;
  //   }
  //   return await db.storelog
  //     .findOne({
  //       selector: {
  //         status: 'miniapp_ok', //miniapp_ok
  //         partition: getOutletId(),
  //       },
  //     })
  //     .sort({ _rev: 'desc' })
  //     .exec();
  // };

  /**
   * Subscribe to RxDB storelog changes for splash flow with retry mechanism
   * Watches for documents with status 'miniapp_ok' and matching partition/id
   * Retries up to 3 times on timeout (20s each) including storelog insert before redirecting to failure
   *
   * @param {number} retryCounter - Current retry attempt count (0-2), defaults to 0
   * @returns {Function} Cleanup function to unsubscribe and clear timeout
   */
  const subscribe = async () => {
    setFrom('splash');
    const now = new Date();
    let timeString = now.toLocaleTimeString(getOutletInfo().localeCode, { hour12: false });
    console.log('subcribe storelog splashscreen called at:', timeString);
    let querySub;
    let timeout;

    timeout = setTimeout(async () => {
      if (!credminiapp) {
        // Check retry limit (max 3 attempts)
        if (retryCounter < 3) {
          // Clean up current subscription before retry
          cleanup();
          try {
            const newId = new ObjectId().toString();
            updateMiniappConfirmId(newId);
            await insertMiniappStoreLogUtil(hitAPI, getOutletId(), newId);
          } catch (error) {
            console.error('Error inserting miniapp storelog to API:', error);
          }
        } else {
          // Max retries reached, log final failure and redirect
          cleanup();
          sendPostMessageToParent('path', URLS.MINIAPP_FAILURE);
          history.replace(URLS.MINIAPP_FAILURE);
        }
        setRetryCounter(retryCounter + 1);
      }
    }, 20000);

    const cleanup = () => {
      if (timeout) clearTimeout(timeout);
      if (querySub) querySub.unsubscribe();
    };

    //standby
    const db = await getDB();
    if (!db || !db.storelog) {
      console.error('Database or storelog collection not ready');
      cleanup();
      return;
    }

    const obj = {
      status: 'miniapp_ok', //miniapp_ok
      partition: getOutletId(),
      id: getMiniappConfirmId(),
    };

    const query = db.storelog
      .findOne({
        selector: obj,
      })
      .sort({ _rev: 'desc' });

    querySub = await query.$.subscribe((doc) => {
      if (doc) {
        console.log('storelog confirm splash received at:', timeString);
        cleanup();
        redirectUrl();
        return;
      }
    });

    // stop watching this query
    return cleanup;
  };

  /**
   * Subscribe to RxDB storelog changes for confirm flow with retry mechanism
   * Watches for documents with status 'miniapp_ok' and matching partition/id
   * Retries up to 3 times on timeout (20s each) including storelog insert before redirecting to failure
   *
   * @param {number} retryCounter - Current retry attempt count (0-2), defaults to 0
   * @returns {Function} Cleanup function to unsubscribe and clear timeout
   */
  const subscribeConfirm = async () => {
    setFrom('confirm');
    const now = new Date();
    let timeString = now.toLocaleTimeString(getOutletInfo().localeCode, { hour12: false });
    console.log('subcribe storelog confirm called at:', timeString);
    let querySub;
    let timeout;

    timeout = setTimeout(async () => {
      // Check retry limit (max 3 attempts)

      if (retryCounter < 3) {
        // Clean up current subscription before retry
        cleanup();
        // Retry the full flow: insert storelog + subscribe 
        const newId = new ObjectId().toString();
        updateMiniappConfirmId(newId);
        await insertMiniappStoreLogUtil(hitAPI, getOutletId(), newId);
      } else {
        // Max retries reached, log final failure and redirect
        cleanup();
        sendPostMessageToParent('path', URLS.MINIAPP_FAILURE);
        history.replace(URLS.MINIAPP_FAILURE);
      }
      setRetryCounter(retryCounter + 1);
      setLocalState({
        messageRetry:
          retryCounter === 1
            ? ' '
            : retryCounter === 2
              ? '.'
              : retryCounter === 3 && '..',
      });
    }, 5000);

    const cleanup = () => {
      if (timeout) clearTimeout(timeout);
      if (querySub) querySub.unsubscribe();
    };

    //standby
    const db = await getDB();
    if (!db || !db.storelog) {
      console.error('Database or storelog collection not ready');
      cleanup();
      return;
    }
    const obj = {
      status: 'miniapp_ok', //miniapp_ok
      partition: getOutletId(),
      id: getMiniappConfirmId(),
    };
    const query = db.storelog
      .findOne({
        selector: obj,
      })
      .sort({ _rev: 'desc' });

    querySub = await query.$.subscribe((doc) => {
      if (doc) {
        console.log('storelog confirm subscribe received at:', timeString);
        cleanup();
        updateMiniappConfirm(true);
        return;
      }
    });

    // stop watching this query
    return cleanup;
  };
 
  useEffect(() => {
    const clients = getClient();
    const client_properties = Object.keys(clients);
    const client_has_properties = client_properties.length > 0;
    const from_splashscreen = from && from === 'splash';
    if (client_has_properties && from_splashscreen) {
      subscribe();
    }
  }, [getClient(), from === 'splash', retryCounter]);

  useEffect(() => {
    if (Object.keys(getClient()).length > 0 && from && from === 'confirm') {
      subscribeConfirm();
    }
  }, [from === 'confirm', retryCounter]);

  useEffect(() => {
    if (!getClient().graphql && getTokenCredentials() && getTokenCredentials().access_token) {
      const client = clientAmplify(getTokenCredentials().access_token);
      updateClient(client);
    }
  }, [getClient()]);

  return [subscribe, subscribeConfirm];
}
